module.exports = __webpack_public_path__ + "img/xiaochengxu.aeecc9a0.webp";